import { render } from "./DogCard.vue?vue&type=template&id=2c709174&scoped=true"
import script from "./DogCard.vue?vue&type=script&lang=js"
export * from "./DogCard.vue?vue&type=script&lang=js"

import "./DogCard.vue?vue&type=style&index=0&id=2c709174&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c709174"

export default script